import api from "../store/services/api";

class DeliveryRadiusService {
  getDeliveryRadius = (params) => {
    return api.get("/delivery-center/delivery-radius/", { params });
  };
  createDeliveryRadius = (deliveryRadius) => {
    return api.post("/delivery-center/delivery-radius/", deliveryRadius, {
      headers: { "Content-Type": "application/json" },
    });
  };
  editDeliveryRadius = (deliveryRadius, deliveryRadiusId) => {
    return api.put(
      `/delivery-center/delivery-radius/?drid=${deliveryRadiusId}`,
      deliveryRadius,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  };
  deleteDeliveryRadius = (deliveryRadiusId) => {
    return api.delete(
      `/delivery-center/delivery-radius/?drid=${deliveryRadiusId}`
    );
  };
  calculateDeliveryRadiusDeliveryTax = (distance) => {
    return api.get(
      `/delivery-center/delivery-radius/delivery-tax?distance=${distance}`
    );
  };
}

export default new DeliveryRadiusService();
